import { TimeSelection } from './types'

export const prefixValue = (value: string | number): string => {
    if (`${value}`.length === 1) {
        return `0${value}`
    }
    return `${value}`
}

export const calculateTimeSelection = (hourInterval: number, minuteInterval: number): TimeSelection => {
    const hours: number[] = []
    const minutes: number[] = []

    for (let hour = 0; hour <= 23; hour += hourInterval) {
        hours.push(hour)
    }

    for (let minute = 0; minute <= 59; minute += minuteInterval) {
        minutes.push(minute)
    }

    return { hours, minutes }
}
